import { FunctionComponent } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const ErrorSkeleton: FunctionComponent = () => (
  <div data-cy="error-skeleton" className="flex flex-wrap w-full gap-4">
    <Skeleton containerClassName="w-full" className="text-4xl" />
    <div className="w-full flex justify-center flex-wrap">
      <Skeleton containerClassName="w-full block" />
      <Skeleton containerClassName="w-3/4 block" />
    </div>
  </div>
);
